import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../auth/auth.service";
import { GtagService } from "../../gtag/gtag.service";
import { CargoFeaturesModel } from "../../model";

@Component({
    selector: 'app-admin-panel',
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.css'],
    standalone: false
})
export class AdminPanelComponent implements OnInit {
  cargoFeatures?: CargoFeaturesModel;
  daysToExpiration: number = 0;

  constructor(public authService: AuthService, private gtag: GtagService) {
    this.gtag.pageview2('Admin');
  }

  async ngOnInit() {
    this.daysToExpiration = (await this.authService.cargoFeatures()).daysToExpiration ?? 0;
  }

}
